<template>
  <h1 class="mt-2 fluid-xl leading-tight font-medium">{{ resultTitle }}</h1>
</template>

<script>
import { computed } from 'vue';
import { useAlgoliaSearch } from '@/composables/useAlgoliaSearch';

export default defineNuxtComponent({
  props: {
    resultType: {
      type: String,
      required: true,
    },
  },

  async setup(props) {
    const { t } = useI18n();
    const { hasRefinements, refinements } = await useAlgoliaSearch();

    const refinementLabels = computed(() => {
      if (!hasRefinements.value) return [];

      // Extract refinement labels from refinements object
      return Object.values(refinements.value);
    });

    // Determine the title based on refinements and result type
    const resultTitle = computed(() => {
      const labels = refinementLabels.value;

      if (props.resultType === 'exercise') {
        return labels.length
          ? t('exercises.showExercisesFor', { facets: labels.join(', ') })
          : t('exercises.showExercisesAll');
      }

      if (props.resultType === 'routine') {
        return labels.length
          ? t('exercises.showRoutinesFor', { facets: labels.join(', ') })
          : t('exercises.showRoutinesAll');
      }

      return '';
    });

    return {
      resultTitle,
    };
  },
});
</script>
